import md5 from 'blueimp-md5';
import configManager from '../config/configManager';

/**
 * 错误返回码 统一处理
 */
export function apiErrorCodeHandling(errorObj) {
  console.log(errorObj, 'errorObj');
  // 错误返回码
  let error_code = Number(errorObj.data.code);
  let message = errorObj?.data?.message || '';
  switch (error_code) {
    // 系统繁忙
    case 401:
      message = `${message}`;
      break;
    // token过期
    case 402:
      // message = `ERROR_CODE:${error_code}::TOKEN_EXPIRE`
      message = `登录已失效，请重新登录`;
      break;

    default:
      message = `ERROR_CODE:${error_code}::UNKNOWN ERROR`;
      break;
  }
  const isUniAppEnv = typeof uni !== 'undefined';
  if (isUniAppEnv) {
    uni.showToast({
      title: message,
      icon: 'none',
      duration: 3000,
      mask: true
    });
  }
}

/**
 * HTTP 状态码 错误处理
 */
export function httpCodeHandling(response) {
  if (!response) {
    uni.showToast({
      title: `无法连接至服务器`,
      icon: 'none',
      duration: 2000
    });
    return false;
  }
  const code = response.statusCode;
  let message = '';
  if (response.errMsg) {
    if (response.errMsg == 'request:fail abort') {
      return false;
    }
    message = response.errMsg;
  }
  if (response.data) {
    message = response.data.message || '';
  }
  switch (code) {
    case 401:
      break;
    case 402:
      message = `登录已失效，请重新登录`;
      break;
    case 404:
      message = `接口不存在`;
      break;
    case 408:
      message = '服务器繁忙,请稍后再试';
      break;
    case 500:
      message = '服务器错误,请稍后再试';
      break;
    default:
      message = `UNHANDLED_HTTP_CODE:${code}`;
      break;
  }
  const isUniAppEnv = typeof uni !== 'undefined';
  if (isUniAppEnv) {
    uni.showToast({
      title: message,
      icon: 'none',
      duration: 3000,
      mask: true
    });
  }
}

/**
 * 生成sign
 * @param {object} params get的query参数， post的query、body参数
 */
export function generateSign(params) {
  // 签名的key
  const signKey = configManager.get('SIGN_KEY');
  let keyArrSort = Object.keys(params).sort();
  let sign = '';
  keyArrSort.map((key, index) => {
    let val = params[key];
    if (
      val !== '' &&
      val !== null &&
      val !== undefined &&
      typeof val !== 'object' &&
      typeof val !== 'boolean'
    ) {
      sign += `${key}=${val}&`;
    }
  });
  if (sign.substr(-1) == '&') {
    sign = sign.substring(0, sign.length - 1);
  }
  sign = sign + signKey;
  return md5(sign);
}

/**
 * 筛选得到非null字段
 * @param {object} params 对象
 */
export function filterObjectNullVal(params) {
  const result = {};
  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      const isNullVal = params[key] === null;
      if (!isNullVal) {
        result[key] = params[key];
      }
    }
  }
  return result;
}

// 解析url?后面的参数
export function parseURL(url) {
  let theRequest = {};
  if (url.indexOf('?') != -1) {
    let str = url.split('?')[1];
    let strs = str.split('&');
    strs.map((item) => {
      let val = item.split('=');
      theRequest[val[0]] = decodeURIComponent(val[1]);
    });
  }
  return theRequest;
}

/**
 * 将服务器返回的SSE数据，拆分成多行
 * @param str
 * @returns {*[]}
 */
export function splitDataLines(str) {
  let regex = /data:(.*?)(?=data:|$)/gs;
  let matches = [];
  let match;

  while ((match = regex.exec(str))) {
    matches.push(match[0].trim());
  }

  return matches;
}

/**
 *
 * @param string
 */
export const dataEmitMessage = (string) => {
  const lines = splitDataLines(string);
  let str = '';
  for (const line of lines) {
    if (line.startsWith('data: ')) {
      const data = line.substring(6);
      if (data === '[DONE]') {
        break;
      }
      try {
        const json = JSON.parse(data);
        if (json?.text) {
          str = json.text;
        } else if (json?.answer) {
          str = json.answer;
        } else {
          str = json;
        }
      } catch (e) {
        console.warn('数据解析失败：' + data);
      }
    }
  }
  return str;
};

/**
 * 模拟TextDecoder(微信小程序环境)
 * @param view
 * @returns {string}
 */
export function textDecode(view) {
  if (!ArrayBuffer.isView(view)) {
    throw new TypeError('passed argument must be an array buffer view');
  }
  const arr = new Uint8Array(view.buffer, view.byteOffset, view.byteLength),
    charArr = Array.from(arr);
  arr.forEach(function (code, i) {
    charArr[i] = String.fromCharCode(code);
  });
  return decodeURIComponent(escape(charArr.join('')));
}
